module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uploader', {
    ref: "uploader",
    staticClass: "file-uploader-container",
    attrs: {
      "options": _vm.options,
      "fileStatusText": _vm.fileStatusText
    },
    on: {
      "upload-start": _vm.onStart,
      "file-error": _vm.onFileError,
      "file-success": _vm.onFileSuccess,
      "complete": _vm.onComplete
    }
  }, [_c('uploader-unsupport'), _c('uploader-btn', {
    ref: "trigger",
    staticClass: "uploader-btn",
    attrs: {
      "attrs": _vm.attrs,
      "single": !_vm.multiple
    }
  }), _c('div', {
    staticClass: "uploader-trigger",
    class: {
      'trigger-disabled': _vm.uploading
    },
    on: {
      "click": _vm.onTrigger
    }
  }, [_vm._t("default")], 2), (_vm.tips) ? _c('div', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.tips))]) : _vm._e(), _c('div', {
    staticClass: "files"
  }, _vm._l((_vm.files), function(file, index) {
    return _c('div', {
      key: file.id,
      staticClass: "file",
      on: {
        "click": function($event) {
          return _vm.onClear(index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-document"
    }), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(file.name || file.attachment_file_name))]), _c('i', {
      staticClass: "el-icon-circle-check icon"
    }), _c('i', {
      staticClass: "el-icon-close clear"
    })])
  }), 0), _c('mu-dialog', {
    attrs: {
      "open": _vm.listVisible,
      "title": "文件上传"
    },
    on: {
      "update:open": function($event) {
        _vm.listVisible = $event
      },
      "close": _vm.onCancel
    }
  }, [_c('uploader-list'), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "primary",
      "label": "关闭",
      "loading": _vm.uploading
    },
    on: {
      "click": _vm.onConfirm
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00f2fc7d","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FileUploader.vue
// module id = 560
// module chunks = 85